export const Enviroments = {
  API_URL: "https://aviator-manager-app.herokuapp.com/",
  API_URL_NODE: "https://api-aviator-cb5db3cad4c0.herokuapp.com/"
};
